import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { AppUserPOSTFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkAppUserPOSTErrorResponse, ParkAppUserPOSTRequest, ParkAppUserPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const createAppUser = async (requestData: ParkAppUserPOSTRequest): Promise<ParkAppUserPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkAppUserPOSTSuccessResponse>("/appuser", requestData);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkAppUserPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: AppUserPOSTFailReason };
  }
};
